// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"bb3f830e","453":"ebcdc71c"}[chunkId] + ".chunk.js");